import {  DrawingUtils, FaceLandmarker as FaceLandmarkerImpl, HandLandmarker } from '@mediapipe/tasks-vision';
import {FaceLandmarker} from "./FaceLandmarker";
import {createHandLandmarker} from "./HandLandmarker";

import {imageDimensions, videoDimensions} from "../index";
import _ from "lodash";

let faceLandmarker;


export const FaceLandmarkerDefaults = {
    basePath: 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.0/wasm',
    options: {
        baseOptions: {
            modelAssetPath: 'https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task',
            delegate: 'GPU'
        },
        runningMode: 'VIDEO',
        outputFaceBlendshapes: true,
        outputFacialTransformationMatrixes: true,
        numFaces: 4,
    }
}

export const FaceLandmarkerDefaultsImage = {
    basePath: 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.0/wasm',
    options: {
        baseOptions: {
            modelAssetPath: 'https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task',
            delegate: 'GPU'
        },
        runningMode: 'IMAGE',
        outputFaceBlendshapes: true,
        outputFacialTransformationMatrixes: true,
        numFaces: 4,
    }
}



export class FaceLandmarkerWrapper {
    constructor() {
        this.faceLandmarker = null;
        this.faceLandmarkerImage = null;
        this.drawingUtils = null;
        this.handlandmarker = null;
        this.canvas = null;
        this.runningMode = "IMAGE"
    }

    async init(canvas) {
       /* const vision = await FilesetResolver.forVisionTasks(
            "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@latest/wasm",
        );*/
        const {faceLandmarker, vision} = await FaceLandmarker({basePath: FaceLandmarkerDefaults.basePath, options: FaceLandmarkerDefaults.options});
        this.faceLandmarker = faceLandmarker;
        console.log("faceLandmarker initialized")

        let faceLandmarkerImage = await FaceLandmarker({basePath: FaceLandmarkerDefaultsImage.basePath, options: FaceLandmarkerDefaultsImage.options, fileset: vision});
        this.faceLandmarkerImage = faceLandmarkerImage.faceLandmarker;
        console.log("faceLandmarkerImage initialized")
       // this.faceDetector = await FaceDetector({basePath: faceDetectorOptions.basePath, options: faceDetectorOptions.options});
        this.handlandmarker = await createHandLandmarker(vision);
        console.log("handlandmarker initialized")
        if(canvas){
            this.initDrawingUtils(canvas);
        }

    }

    initDrawingUtils(canvas){
        this.canvas = canvas;
        this.clearResults();
        const ctx = canvas.getContext('2d');
        this.drawingUtils = new DrawingUtils(ctx);
        console.log("initDrawingUtils")
    }

    resetDrawingUtils(){
        this.drawingUtils = null;
        this.canvas = null;
        console.log("resetDrawingUtils")
    }

    clearResults(){
        if(this.canvas){
            const ctx = this.canvas.getContext('2d');
            ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        }
    }

    async changeRunningMode(mode){
        // verify mode is valid VIDEO or IMAGE
        if(mode !== "VIDEO" && mode !== "IMAGE"){
            console.error("Invalid running mode", mode)
            return;
        }
        this.runningMode = mode;
        await this.faceLandmarker.setOptions({runningMode: mode})
        await this.handlandmarker.setOptions({runningMode: mode})
        this.drawingUtils = null;
    }

    async syncRunningMode(isImage){
        if(isImage && this.runningMode === "VIDEO" || !isImage && this.runningMode === "IMAGE"){
            await this.changeRunningMode(isImage ? "IMAGE" : "VIDEO")
        }
    }

    async detect(input, detectHands, isImage){
        await this.syncRunningMode(isImage)

        let faces = null
        if(isImage){
           faces = await this.detectForImage(input)
        }else {
            faces = await this.detectForVideo(input)
        }

        this.attachHeadAngles(faces);

        let result = {faces}

        if(detectHands){
            const timestamp = performance.now();
            const hands = isImage ? await this.handlandmarker.detect(input) : await this.handlandmarker.detectForVideo(input, timestamp);
            // console.log("hands", hands)
            result.hands = hands;
        }

        this.attachBoundingBoxes(input, result)

        return result

    }

    async detectHands(input){
        const hands = await this.handlandmarker.detect(input)

        if (hands && hands.landmarks) {
            let inputWidth, inputHeight;

            if (input instanceof HTMLVideoElement) {
                inputWidth = input.videoWidth;
                inputHeight = input.videoHeight;
            } else if (input instanceof HTMLImageElement || input instanceof HTMLCanvasElement) {
                inputWidth = input.width;
                inputHeight = input.height;
            } else {
                console.error("Unsupported input type. Expected a video or an image element.", input);
                return;
            }
           hands.absolutePositionLandmarks = []
            for (const landmarks of hands.landmarks) {
                for (const point of landmarks) {
                    const {x, y} = point;
                    const [cx, cy] = [x * inputWidth, y * inputHeight];
                    hands.absolutePositionLandmarks.push({x: cx, y: cy});
                }
            }
        }
        return {hands, faces: {
                boundingBoxes: [],
                faceLandmarks: [],
                faceBlendshapes: [],
                headAngles: []
            }};
    }


    async detectForVideo(input, detectHands) {
        const timestamp = Date.now();
      //  const faces = await this.faceDetector.detectForVideo(input, timestamp);
        const faces = await this.faceLandmarker.detectForVideo(input, timestamp);
       /* this.attachHeadAngles(faces);
        let result = {faces};

        if(detectHands){
            const hands = await this.handlandmarker.detectForVideo(input, timestamp);
            // console.log("hands", hands)
            result.hands = hands;
        }

        this.attachBoundingBoxes(input, result)

        console.log("result", result)*/

        return faces;

    }

    async detectForImage(input) {
        const faces = await this.faceLandmarkerImage.detect(input);
      //  console.log("detectForImage", faces)
        return faces;
    }

    attachHeadAngles(faces){
        if (faces && faces.faceLandmarks) {
            faces.headAngles = []
            for (const matrix of faces.facialTransformationMatrixes) {
                const headAngles = extractYawPitchRoll(matrix.data);
                faces.headAngles.push(headAngles);
               // console.log("headAngles", headAngles)
            }
        }
    }

    attachBoundingBoxes(input, result) {
        let [cx_min, cy_min] = [Infinity, Infinity];
        let [cx_max, cy_max] = [-Infinity, -Infinity];
        let inputWidth, inputHeight;

        // Determine whether the input is a video or an image
        if (input instanceof HTMLVideoElement) {
            inputWidth = input.videoWidth;
            inputHeight = input.videoHeight;
        } else if (input instanceof HTMLImageElement || input instanceof HTMLCanvasElement) {
            inputWidth = input.width;
            inputHeight = input.height;
        } else {
            console.error("Unsupported input type. Expected a video or an image element.", input);
            return;
        }

        if (result && result.faces && result.faces.faceLandmarks) {
            result.faces.boundingBoxes = []
            for (const landmarks of result.faces.faceLandmarks) {
                // Reset min and max for each face
                [cx_min, cy_min] = [Infinity, Infinity];
                [cx_max, cy_max] = [-Infinity, -Infinity];

                for (const point of landmarks) {
                    const {x, y} = point;
                    const [cx, cy] = [x * inputWidth, y * inputHeight];
                    cx_min = Math.min(cx, cx_min);
                    cy_min = Math.min(cy, cy_min);
                    cx_max = Math.max(cx, cx_max);
                    cy_max = Math.max(cy, cy_max);
                }

                const width = cx_max - cx_min;
                const height = cy_max - cy_min;
                const x = cx_min;
                const y = cy_min;
                const rect = { x, y, width, height };
                result.faces.boundingBoxes.push(rect);
            }
        }

        if (result && result.hands && result.hands.landmarks) {
            result.hands.absolutePositionLandmarks = []
            for (const landmarks of result.hands.landmarks) {
                for (const point of landmarks) {
                    const {x, y} = point;
                    const [cx, cy] = [x * inputWidth, y * inputHeight];
                    result.hands.absolutePositionLandmarks.push({x: cx, y: cy});
                }
            }
        }
    }

    drawResults(results, canvas, input, color = "#cc1d6c", log = false) {
        if(!this.drawingUtils){
            this.initDrawingUtils(canvas)
        }

        this.clearResults();

        let inputWidth, inputHeight, displaySize;

        // Determine whether the input is a video or an image
        if (input instanceof HTMLVideoElement) {
            inputWidth = input.videoWidth;
            inputHeight = input.videoHeight;
            displaySize = videoDimensions(input)
        } else if (input instanceof HTMLImageElement || input instanceof HTMLCanvasElement) {
            inputWidth = input.width;
            inputHeight = input.height;
            displaySize = imageDimensions(input)
        } else {
            console.error("Unsupported input type. Expected a video or an image element.");
            return;
        }



        canvas.style.width = displaySize.width + "px";
        canvas.style.height = displaySize.height + "px";
        canvas.width = inputWidth;
        canvas.height = inputHeight;


        const {faces, hands} = results;

        if (faces.faceLandmarks) {
            for (const landmarks of faces.faceLandmarks) {
                if(log){
                    console.log("landmarks", landmarks)
                }

                this.drawingUtils.drawConnectors(
                    landmarks,
                    FaceLandmarkerImpl.FACE_LANDMARKS_TESSELATION,
                    { color: "#C0C0C070", lineWidth: 1 }
                );
                this.drawingUtils.drawConnectors(
                    landmarks,
                    FaceLandmarkerImpl.FACE_LANDMARKS_RIGHT_EYE,
                    { color: color }
                );
                this.drawingUtils.drawConnectors(
                    landmarks,
                    FaceLandmarkerImpl.FACE_LANDMARKS_RIGHT_EYEBROW,
                    { color: color }
                );
                this.drawingUtils.drawConnectors(
                    landmarks,
                    FaceLandmarkerImpl.FACE_LANDMARKS_LEFT_EYE,
                    { color: color }
                );
                this.drawingUtils.drawConnectors(
                    landmarks,
                    FaceLandmarkerImpl.FACE_LANDMARKS_LEFT_EYEBROW,
                    { color: color }
                );
                this.drawingUtils.drawConnectors(
                    landmarks,
                    FaceLandmarkerImpl.FACE_LANDMARKS_FACE_OVAL,
                    { color: color }
                );
                this.drawingUtils.drawConnectors(
                    landmarks,
                    FaceLandmarkerImpl.FACE_LANDMARKS_LIPS,
                    { color: color }
                );
                this.drawingUtils.drawConnectors(
                    landmarks,
                    FaceLandmarkerImpl.FACE_LANDMARKS_RIGHT_IRIS,
                    { color: color }
                );
                this.drawingUtils.drawConnectors(
                    landmarks,
                    FaceLandmarkerImpl.FACE_LANDMARKS_LEFT_IRIS,
                    { color: color }
                );
            }
        }

        if(hands) {
            for (const landmarks of hands.landmarks) {
                this.drawingUtils.drawConnectors(landmarks, HandLandmarker.HAND_CONNECTIONS, {
                    color: color,
                    lineWidth: 5
                });
                this.drawingUtils.drawLandmarks(landmarks, {color: color, lineWidth: 1});
            }
        }
    }

}

/*export async function createFaceLandmarker() {
    console.log("createFaceLandmarker")
    const vision = await FilesetResolver.forVisionTasks(
        "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@latest/wasm",
    );
    faceLandmarker = await FaceLandmarker.createFromOptions(vision, {
        baseOptions: {
            modelAssetPath: face_landmarker_task
        },
        outputFaceBlendshapes: true,
        runningMode,
        numFaces: 1
    });
    console.log("faceLandmarker", faceLandmarker)
    //demosSection.classList.remove("invisible");
}*/


export const detectFaceLandmarks = async (input, fromCamera = true) => {
    //console.time("detectFaceLandmarks")

    const faces = await faceLandmarker.detectForVideo(input);
    // console.timeEnd("detectFaceLandmarks")
    return faces;
}

function extractYawPitchRoll(matrixObj) {
    // Extract the flat array from the matrix object
    const data = matrixObj;

    // Assuming a 4x4 matrix, access elements as if it's a flat array
    const r11 = data[0], r12 = data[1], r13 = data[2];
    const r21 = data[4], r22 = data[5], r23 = data[6];
    const r31 = data[8], r32 = data[9], r33 = data[10];

    // Calculate yaw, pitch, and roll
    const roll = Math.atan2(r21, r11);
    const yaw = Math.atan2(-r31, Math.sqrt(r32 * r32 + r33 * r33));
    const pitch = Math.atan2(r32, r33);

    // Convert to degrees
    return {
        pitch: pitch * 180 / Math.PI,
        yaw: yaw * 180 / Math.PI,
        roll: roll * 180 / Math.PI
    };
}

export function extractEyesDirection(faceBlendshapes){
    let eyesLookDown = _.mean([faceBlendshapes.eyeLookDownLeft, faceBlendshapes.eyeLookDownRight]);
    let eyesLookLeft = _.mean([faceBlendshapes.eyeLookInRight, faceBlendshapes.eyeLookOutLeft]);
    let eyesLookRight = _.mean([faceBlendshapes.eyeLookInLeft, faceBlendshapes.eyeLookOutRight]);
    let eyesLookUp = _.mean([faceBlendshapes.eyeLookUpLeft, faceBlendshapes.eyeLookUpRight]);

    // calc x,y direction of eyes
    let eyesX = eyesLookLeft - eyesLookRight;
    let eyesY = eyesLookUp - eyesLookDown;

    return {x: eyesX, y: -1 * eyesY, rightX: eyesLookRight, leftX: eyesLookLeft, upY: eyesLookUp, downY: eyesLookDown}
}
